/* Svensk katalog for locale-no.js (del 6 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'buy.editPurchaseHelp': 'Sparar ändringarna i det bokförda köpet.',
  'adv.tax.choices.title': 'Om det här var mitt bolag',
  'adv.tax.myRecommendation': 'Min rekommendation:',
  'adv.tax.wait': 'Vänta',
  'adv.tax.recommendWait': 'Rekommendation: vänta',
  'adv.tax.showCalculation': 'Visa beräkning',
  'adv.tax.line.tax': 'Skatt',
  'adv.tax.line.liquidity': 'Likviditet',
  'adv.tax.line.netCost': 'Nettokostnad',
  'adv.tax.fig.taxBaseReduction': 'Minskning av skatteunderlaget',
  'adv.tax.fig.taxSaving': 'Uppskattad skattebesparing',
  'adv.tax.fig.liquidityEffect': 'Likviditetseffekt',
  'adv.tax.fig.netCost': 'Nettokostnad efter skatteeffekt',
  'adv.tax.rateNote.corporate': 'Skattebesparingen är beräknad med {pct} % bolagsskatt.',
  'adv.tax.rateNote.soleTrader': 'Skattebesparingen är beräknad med {pct} %, som är Plummes vägledande skattesats för enskild näringsidkare. Faktisk marginalskatt beror på trinnskatt, trygdeavgift och dina personliga förhållanden.',
  'adv.tax.proposal.taxReserve.title': 'Avsätt till skatt',
  'adv.tax.proposal.taxReserve.desc': 'Resultatet hittills tyder på att du bör reservera {amount} före privata uttag eller större köp. Det sänker inte skatten — det ser till att pengarna finns när räkningen kommer.',
  'adv.tax.proposal.vatDue.title': 'Moms som måste täckas',
  'adv.tax.proposal.vatDue.desc': 'Beräknad moms från bokförda försäljningar och köp är {amount}. Kontrollera perioden före inlämning.',
  'adv.tax.proposal.buyAssets.title': 'Köp av inventarier före årets slut',
  'adv.tax.proposal.buyAssets.desc': 'Du har {count} planerad(e) investering(ar) på sammanlagt {amount}. Skattesiffrorna nedan är en illustration; typ av inventarie, användning och livslängd måste kontrolleras för varje köp.',
  'adv.tax.proposal.missingVouchers.title': 'Verifikationer som saknas',
  'adv.tax.proposal.missingVouchers.desc': '{count} bokförda köp på sammanlagt {amount} saknar verifikation. Kontrollera om varje köp ger avdrag eller ingående moms.',
  'adv.tax.calc.taxReserveBase': 'Skattebufferten är {pct} % av resultatet hittills, minus inbetald preliminärskatt: {amount}.',
  'adv.tax.calc.vatDueBase': 'Utgående moms minus ingående moms under perioden: {amount}.',
  'adv.tax.calc.assetCapitalize': 'Illustrationen behandlar {amount} som en kvalificerande inventarie över gränsen för direktavdrag ({limit}).',
  'adv.tax.calc.assetDirect': 'Illustrationen förutsätter att köpet på {amount} kvalificerar för direktavdrag under gränsen ({limit}).',
  'adv.tax.calc.assetDepreciation': 'Illustration om inventarien hör till saldogrupp d: {pct} % första året = {amount}.',
  'adv.tax.calc.assetSaving': '{reduction} lägre skatteunderlag × {pct} % = {saving} i sparad skatt.',
  'adv.tax.calc.voucherBase': '{count} bokförda köp utan verifikation, sammanlagt {amount} exklusive moms. Beloppet är inte ett beräknat avdrag.',
  'adv.tax.calc.voucherSaving': '{amount} i avdrag × {pct} % = {saving} i sparad skatt, förutsatt att verifikationerna kommer på plats.',
  'adv.tax.calc.voucherVat': 'Dessutom riskeras {vat} i ingående moms utan dokumentation.',
  'adv.tax.choice.buyAssets.q': 'Köpa inventarierna före nyår?',
  'adv.tax.choice.buyAssets.reco.wait': 'Vänta med köpet. Prognosen visar att bufferten inte klarar utflödet på {amount} nu. Kontrollera behov och skattemässig behandling per inventarie innan du väljer tidpunkt.',
  'adv.tax.choice.buyAssets.reco.do': 'Bufferten klarar utflödet på {amount}. Genomför bara om inventarien behövs, och kontrollera skattebehandlingen per köp. En möjlig skattefördel är inte ensam ett skäl att köpa.',
  'adv.tax.choice.buyAssets.reco.consider': 'Bedöm det tillsammans med din redovisningskonsult. Jag har inte tillräckligt med likviditetsdata för att avgöra om bufferten klarar utflödet på {amount} i år.',
  'adv.tax.choice.taxReserve.q': 'Avsätta till skatt nu?',
  'adv.tax.choice.taxReserve.reco.do': 'Gör det. {amount} är pengar du redan är skyldig — de är bara inte avskilda ännu. Avsätter du dem nu slipper du leta fram dem när tidsfristen kommer.',
  'adv.tax.choice.taxReserve.reco.wait': 'Vänta lite. Bufferten är stram just nu — men {amount} måste finnas på plats före tidsfristen.',
  'adv.tax.choice.taxReserve.reco.consider': 'Överväg att avsätta {amount} nu, så att pengarna finns när tidsfristen kommer.',
  'adv.tax.choice.missingVouchers.q': 'Städa upp de saknade verifikationerna?',
  'adv.tax.choice.missingVouchers.reco.do': 'Gör det före periodens slut. Hitta de {count} verifikationer som saknas och kontrollera vilka köp som faktiskt kan ge avdrag eller ingående moms.',
  'adv.tax.choice.missingVouchers.reco.wait': 'Ta det före periodens slut. {count} verifikationer saknas; bedöm avdragsrätten för varje köp.',
  'adv.tax.choice.missingVouchers.reco.consider': 'Skaffa de {count} verifikationer som saknas och bedöm om köpen är avdragsgilla.',
  'adv.report.emptyTitle': 'Rapporter visas här',
  'adv.report.emptyText': 'Rapportvyn kopplas på när AI-rådgivaren får backend-data.',
  'adv.bench.title': 'Jämförelse med tidigare siffror',
  'adv.bench.sub': 'Dina nyckeltal mot valt jämförelseunderlag',
  'adv.bench.help': 'Här ser du dina egna nyckeltal mot föregående år eller en rekommenderad intern tröskel. Märket till höger visar om utvecklingen pekar åt rätt håll för varje tal.',
  'adv.bench.rowHelp': 'Ditt företag: {you} · jämförelse: {avg}. {verdict}{direction}',
  'adv.bench.rowBetter': 'Utvecklingen är bättre på det här måttet.',
  'adv.bench.rowWorse': 'Det här är ett område du kan titta närmare på.',
  'adv.bench.higherBetter': ' Här är högre bättre.',
  'adv.bench.lowerBetter': ' Här är lägre bättre.',
  'adv.bench.stronger': 'Starkare',
  'adv.bench.weaker': 'Svagare',
  'adv.bench.you': 'Ditt företag',
  'adv.bench.comparison': 'Jämförelse',
  'adv.bench.emptyTitle': 'Ingen jämförelse än',
  'adv.bench.emptyText': 'Jämförelse kräver nyckeltal för valt år och ett tidigare år eller en intern tröskel.',
  'adv.verdict.tag': 'Vad händer just nu?',
  'adv.verdict.liquidityBufferBreach': 'Beräknat saldo från bokförda siffror ligger {shortfall} under bufferten på {buffer} i {month}. Kontrollera kommande betalningar innan du väljer åtgärd.',
  'adv.verdict.liquidityOverdue': 'Förfallna kundfakturor på {amount} är inte registrerade som inbetalda. Det kan påverka likviditeten även om beräknat saldo ligger över bufferten.',
  'adv.verdict.liquidityNoForwardData': 'Den här vyn har inga kommande månader med beräknat saldo. Öppna poster och bufferten kan fortfarande följas upp.',
  'adv.verdict.liquidityOk': 'Beräknat saldo ligger över bufferten under de månader som visas. Öppna poster och betalningar som inte är registrerade kan ändra bilden.',
  'adv.verdict.costSpike': '{name} har ökat {pct} % jämfört med jämförelseperioden. Det är den kostnaden jag skulle titta närmare på först.',
  'adv.verdict.costUp': 'Kostnaderna har ökat {pct} % jämfört med föregående år. Ingen enskild post sticker ut, men sammantaget är utvecklingen värd en titt.',
  'adv.verdict.costDown': 'Kostnaderna har minskat {pct} % jämfört med föregående år. Det är god kostnadskontroll.',
  'adv.verdict.costFlat': 'Kostnaderna ligger stabilt på {amount}. Inget som kräver åtgärd nu.',
  'adv.verdict.costNoComparison': 'Du har bokfört {amount} i kostnader. Jag saknar siffror från föregående år, så jag kan inte säga om utvecklingen går åt rätt håll än.',
  'adv.verdict.taxBoth': 'Du har {vat} i moms och {buffer} som bör sättas av till skatt. Se till att pengarna finns när förfallodagarna kommer.',
  'adv.verdict.taxVat': 'Du har {vat} i moms som ska täckas. Sätt av beloppet före förfallodagen.',
  'adv.verdict.taxBuffer': 'Resultatet tyder på att du bör sätta av {buffer} till skatt innan du tar ut pengar privat.',
  'adv.verdict.taxNothingDue': 'Jag hittar ingen moms eller skatteavsättning som förfaller nu. Använd fliken som checklista före inlämning.',
  'adv.verdict.reportProfit': 'Perioden ger ett överskott på {result} — {income} in och {costs} ut.',
  'adv.verdict.reportLoss': 'Perioden ger ett underskott på {result} — {income} in och {costs} ut.',
  'adv.verdict.benchAllStronger': 'Du ligger starkare på alla {total} nyckeltal jag jämför. Det är stabilt.',
  'adv.verdict.benchMixed': 'Du ligger starkare på {better} av {total} nyckeltal. Resten är där jag skulle leta efter förbättringar.',
  'adv.verdict.benchAllWeaker': 'Du ligger svagare på alla {total} nyckeltal jag jämför. Börja med det som betyder mest för kassaflödet.',
  'adv.verdict.benchNoData': 'Jag saknar underlag för att jämföra dina nyckeltal än.',
  'adv.why.title': 'Varför händer det?',
  'adv.why.liquiditySub': 'Öppna poster och avsättningar som du bör se tillsammans med beräknat saldo',
  'adv.liquidity.watchTitle': 'Det här håller jag också koll på',
  'adv.liquidity.watchBelowBuffer': 'Saknas till bufferten i {month}',
  'adv.liquidity.watchAboveBuffer': 'Marginal över bufferten i {month}',
  'adv.liquidity.watchNoBalance': 'Ingen kommande månad med beräknat saldo',
  'adv.liquidity.watchReceivables': 'Kundfakturor som inte har förfallit',
  'adv.liquidity.watchPayables': 'Leverantörsfakturor som inte har förfallit',
  'adv.liquidity.scope': 'Bedömningen bygger på bokförda intäkter och kostnader, öppna poster och buffertgränsen. Planerade betalningar som inte är registrerade i Plumme är inte med.',
  'adv.why.costTitle': 'Det här lade jag märke till',
  'adv.why.whyOverdueSales': 'Förfallna kundfakturor',
  'adv.why.whyOverduePurchases': 'Förfallna leverantörsfakturor',
  'adv.why.whyPublicDues': 'Moms och skatteavsättning som förfaller',
  'adv.why.whyCostUp': '{name} — upp {pct} % jämfört med jämförelseperioden',
  'adv.why.whyCostLargest': '{name} — din största kostnadspost',
  'adv.moves.title': 'Om det här var mitt företag',
  'adv.moves.liquiditySub': 'Förfallna poster, kommande moms, prognosbuffert och försäljningsdokument som behöver följas upp.',
  'adv.moves.costTitle': 'Möjligheter',
  'adv.moves.costSub': 'Pengar du kan ta in eller sluta spendera',
  'adv.moves.go': 'Öppna',
  'adv.moves.showAll': 'Visa alla {count}',
  'adv.moves.count': '{count} st.',
  'adv.moves.followup': 'Att följa upp',
  'adv.moves.amount': 'Belopp',
  'adv.moves.moveAcceptedOffer': 'Följ upp accepterade offerter ({count})',
  'adv.moves.moveAcceptedOffer.note': 'Ingen kopplad faktura eller fakturautkast',
  'adv.moves.moveFollowUpOffer': 'Följ upp skickade offerter ({count})',
  'adv.moves.moveFollowUpOffer.note': 'Väntar på svar eller närmar sig giltighetsdatum',
  'adv.moves.moveSendOffer': 'Skicka oskickade offerter ({count})',
  'adv.moves.moveSendOffer.note': 'Skapade men inte skickade till kunden',
  'adv.moves.moveOfferDrafts': 'Slutför offertutkast ({count})',
  'adv.moves.moveOfferDrafts.note': 'Utkast som inte har skapats och skickats',
  'adv.moves.moveInvoiceDrafts': 'Gå igenom fakturautkast ({count})',
  'adv.moves.moveInvoiceDrafts.note': 'Utkast som har legat i minst sju dagar',
  'adv.moves.moveChaseOverdue': 'Skicka påminnelse om de förfallna kundfakturorna',
  'adv.moves.moveSetAsideVat': 'Sätt av moms före förfallodagen',
  'adv.moves.moveBuildBuffer': 'Bygg upp bufferten före {month}',
  'adv.moves.movePayOverdue': 'Betala de förfallna leverantörsfakturorna',
  'adv.moves.moveReviewCost': 'Gå igenom {name}',
  'adv.moves.moveFixVouchers': 'Ladda upp {count} saknade verifikationer',
  'adv.moves.moveWatchCosts': 'Inga kostnadsåtgärder behövs nu',
  'adv.gain.gainCashflow': 'bättre kassaflöde',
  'adv.gain.gainAvoidInterest': 'du undviker dröjsmålsränta',
  'adv.gain.gainToBuffer': 'saknas till bufferten',
  'adv.gain.gainAvoidFees': 'du undviker avgifter och påminnelser',
  'adv.gain.gainCostIncrease': 'ökningen jämfört med jämförelseperioden',
  'adv.gain.gainDeductionRisk': 'avdrag du riskerar att förlora utan verifikationer',
  'adv.gain.gainNoActionNeeded': 'kostnaderna är under kontroll',
  'adv.monitor.title': 'SuperPlumma övervakar',
  'adv.monitor.sub': 'Det här kontrollerar jag varje gång siffrorna ändras',
  'adv.monitor.help': 'Kontrollerna som SuperPlumma kör automatiskt mot bokföringen. Grönt betyder att kontrollen är i ordning nu, gult att något bör granskas.',
  'adv.monitor.monitorLiquidity': 'Likviditetsbuffert',
  'adv.monitor.monitorOverdueSales': 'Förfallna kundfakturor',
  'adv.monitor.monitorOverduePurchases': 'Förfallna leverantörsfakturor',
  'adv.monitor.monitorVat': 'Moms som förfaller',
  'adv.monitor.monitorVouchers': 'Verifikationer på inköp',
  'adv.monitor.monitorConcentration': 'Kundberoende',
  'adv.monitor.group.liquidity': 'Likviditet',
  'adv.monitor.group.receivables': 'Inbetalningar',
  'adv.monitor.group.costs': 'Kostnader och leverantörer',
  'adv.monitor.group.tax': 'Skatt och tidsfrister',
  'adv.monitor.group.quality': 'Bokföringskvalitet',
  'adv.monitor.group.sales': 'Försäljning och lönsamhet',
  'adv.monitor.detail.liquidityBelow': 'Beräknat saldo från bokförda siffror ligger under bufferten på {amount} i månad {month}.',
  'adv.monitor.detail.liquidityOk': 'Beräknat saldo från bokförda siffror håller sig över vald buffert under kommande månader.',
  'adv.monitor.detail.liquidityNoData': 'Inga kommande månader med beräknat saldo under vald period.',
  'adv.monitor.detail.receivablesOld': '{amount} har förfallit; äldsta fordran är {days} dagar.',
  'adv.monitor.detail.receivablesOverdue': '{amount} i kundfordringar har förfallit.',
  'adv.monitor.detail.receivablesSlower': 'Kunderna tar i snitt {days} dagar längre på sig att betala.',
  'adv.monitor.detail.receivablesOk': 'Inga förfallna kundfordringar kräver uppföljning.',
  'adv.monitor.detail.receivablesNoData': 'Det finns inte tillräckligt med försäljningsdata för att bedöma inbetalningarna.',
  'adv.monitor.detail.costsSupplierOverdue': '{amount} i leverantörsskulder har förfallit.',
  'adv.monitor.detail.costsSupplierDependency': '{name} står för {pct} % av årets kostnader.',
  'adv.monitor.detail.costsBudgetOver': 'Kostnaderna ligger {pct} % över budget hittills.',
  'adv.monitor.detail.costsIncrease': 'Kostnaderna har ökat {pct} % jämfört med motsvarande period.',
  'adv.monitor.detail.costsOk': 'Inga väsentliga kostnads- eller leverantörsavvikelser.',
  'adv.monitor.detail.costsNoData': 'Det finns inte tillräckligt med kostnadsdata för att bedöma avvikelser.',
  'adv.monitor.detail.taxDeadline': 'Antal tidsfrister som bör följas upp: {count}.',
  'adv.monitor.detail.taxVat': 'Beräknad moms som måste täckas är {amount}.',
  'adv.monitor.detail.taxOk': 'Inga beräknade momsbelopp eller nära tidsfrister kräver åtgärd.',
  'adv.monitor.detail.taxNoData': 'Det finns inte tillräckligt med bokföringsdata för att bedöma moms och skatt.',
  'adv.monitor.detail.qualityVouchers': '{count} bokförda köp saknar verifikation.',
  'adv.monitor.detail.qualityBank': '{count} bankrader är inte färdigavstämda.',
  'adv.monitor.detail.qualityStale': 'Senaste bokföringsaktivitet är {days} dagar gammal.',
  'adv.monitor.detail.qualityImportedAggregate': 'Importerade summor kan analyseras, men verifikationernas fullständighet kan inte kontrolleras utan de enskilda posterna.',
  'adv.monitor.detail.qualityNoData': 'Det finns inte tillräckligt med aktivitet under valt år för att bedöma kvaliteten.',
  'adv.monitor.detail.qualityOk': 'Verifikationer och eventuella bankrader ser ordnade ut.',
  'adv.monitor.detail.salesBudgetBelow': 'Omsättningen ligger {pct} % under budget hittills.',
  'adv.monitor.detail.salesRevenueDrop': 'Omsättningen har minskat {pct} % jämfört med motsvarande period.',
  'adv.monitor.detail.salesNegativeMargin': 'Resultatmarginalen är {pct} %.',
  'adv.monitor.detail.salesCustomerDependency': '{name} står för {pct} % av årets omsättning.',
  'adv.monitor.detail.salesOk': 'Inga väsentliga avvikelser i försäljning eller lönsamhet.',
  'adv.monitor.detail.salesNoData': 'Det finns inte tillräckligt med försäljningsdata för att bedöma utvecklingen.',
  'adv.conf.buildsOn': 'Bygger på',
  'adv.conf.missing': 'Saknas',
  'adv.conf.nothingYet': 'Inga bokförda siffror ännu',
  'adv.conf.nothingMissing': 'Ingenting saknas',
  'adv.conf.postedIncome': 'Bokförda intäkter',
  'adv.conf.postedCosts': 'Bokförda kostnader',
  'adv.conf.openItems': 'Öppna poster',
  'adv.conf.previousYear': 'Fjolårssiffror',
  'adv.conf.customerSplit': 'Försäljning per kund',
  'adv.conf.completeVouchers': 'Kompletta verifikationer',
  'adv.conf.importedVoucherDetails': 'Detaljunderlag för importerade verifikationer',
  'adv.why.recWhyOverdueCash': 'Pengarna är redan intjänade — de är bara obetalda',
  'adv.why.recWhyOverdueBuffer': 'Prognosen faller under din buffert utan dessa inbetalningar',
  'adv.why.recWhyVatDeadline': 'Momsen förfaller på fast termin och kan inte skjutas upp',
  'adv.why.recWhyVatInterest': 'Försenad betalning ger dröjsmålsränta och avgift',
  'adv.why.recWhyVoucherDeduction': 'Utan verifikation kan avdraget strykas vid kontroll',
  'adv.why.recWhyVoucherAudit': 'Bokføringsloven kräver dokumentation för varje post',
  'adv.why.recWhyCostGrowth': 'Kostnaderna växer {pct} % jämfört med fjolåret',
  'adv.chat.placeholder': 'Skriv ett meddelande …',
  'adv.chat.send': 'Skicka',
  'adv.chat.fallbackToast': 'SuperPlumma svarade med lokal reservlösning.',
  'adv.chat.limitReached': 'Den här konversationen har nått gränsen på {max} frågor. Starta en ny konversation för att fortsätta.',
  'adv.chat.limitNear': '{left} frågor kvar i den här konversationen.',
  'adv.chat.newChat': 'Starta ny konversation',
  'adv.chat.business.intro': 'Hej! Jag är SuperPlumma, din ekonomiska rådgivare. Jag har gått igenom företagets bokföring och kan svara på det du undrar över — likviditet, kostnader, skatt eller hälsopoängen. Vad vill du titta närmare på?',
  'adv.chat.business.sugg1': 'Hur kan jag förbättra likviditeten?',
  'adv.chat.business.sugg2': 'Var kan jag dra ner på kostnader?',
  'adv.chat.business.sugg3': 'Förklara min hälsopoäng',
  'adv.chat.business.sugg4': 'När förfaller momsen?',
  'adv.chat.private.intro': 'Hej! Jag är SuperPlumma, din privata rådgivare. Jag har tittat på din ekonomi och kan hjälpa dig med sparande, lån, avdrag, pension och skattemeldingen. Vad har du på hjärtat?',
  'adv.chat.private.sugg1': 'Var kan jag spara pengar?',
  'adv.chat.private.sugg2': 'Bör jag refinansiera bolånet?',
  'adv.chat.private.sugg3': 'Vilka avdrag kan jag få?',
  'adv.chat.private.sugg4': 'Hur ligger jag till med pensionen?',
  'adv.reply.private.saving': 'Jag behöver kopplade data om privatekonomin innan jag kan peka på konkreta besparingar. När data är klara kan jag visa fasta dragningar, abonnemang och ovanliga kostnader.',
  'adv.reply.private.loan': 'Jag kan bedöma lån och ränta när lånedata är kopplade. Tills vidare bör konkreta låneråd kontrolleras mot bankerbjudanden och det faktiska låneavtalet.',
  'adv.reply.private.tax': 'Jag kan hjälpa till med skatt när relevanta privata transaktioner och avdragsunderlag är kopplade. Använd svaret som kontrollpunkt, inte som bindande skatteråd.',
  'adv.reply.private.pension': 'Pensionsråd kräver inkomst-, pensions- och spardata. När det finns tillgängligt kan jag visa utveckling och möjliga justeringar.',
  'adv.reply.private.score': 'Privat hälsopoäng beräknas när privatekonomimodellen har tillräckligt med data.',
  'adv.reply.private.default': 'Bra fråga! Jag kan hjälpa dig med sparande, lån, avdrag, pension och skattemeldingen. Vad vill du börja med?',
  'adv.reply.business.liquidity': 'Jag behöver åtkomst till backend-rådgivaren för att ge konkreta likviditetssiffror. När den är tillgänglig använder jag öppna kundfordringar, leverantörsskulder och rapporterade månadsdata.',
  'adv.reply.business.costs': 'Kostnadsråd bör bygga på bokförda kostnadsrader och jämförelse med tidigare år. Försök igen när SuperPlumma-backend är tillgänglig.',
  'adv.reply.business.tax': 'Skatt och moms måste beräknas från bokförda siffror. Jag ger inga konkreta belopp i den lokala reservlösningen, men backend-rådgivaren kan hämta detta från rapportmodellen.',
  'adv.reply.business.score': 'Hälsopoängen beräknas från faktisk likviditet, tillväxt, lönsamhet och stabilitet när rådgivarmodellen är tillgänglig.',
  'adv.reply.business.invoices': 'Fakturauppföljning kräver öppna fakturor från backend. När data är klara kan jag visa vilka poster som bör följas upp först.',
  'adv.reply.business.default': 'Bra fråga. Jag kan svara konkret när SuperPlumma-backend är tillgänglig; den lokala reservlösningen visar bara allmänna råd utan bokföringssiffror.',
  'trv.sub': 'Reseräkningar, milersättning och utlägg som skickats in från personalportalen. Privata utlägg går till nästa löneutbetalning — företagskort/driftskonto bokförs direkt och hålls utanför lönen.',
  'trv.allEmployees': 'Alla anställda',
  'trv.searchPh': 'Sök på resa, syfte eller anställd',
  'trv.noTravel': 'Inga resor här ännu',
  'trv.noTravelHelp': 'När anställda skickar in resor eller utlägg från personalportalen visas de här.',
  'trv.backToOverview': 'Tillbaka till översikten',
  'trv.approveTravel': 'Godkänn resa',
  'trv.trips': 'Körningar',
  'trv.tripsHelp': 'Kilometerersättning enligt statens sats.',
  'trv.noTrips': 'Inga körningar registrerade.',
  'trv.expenseHelp': 'Privata utlägg återbetalas via lönen. Företagskort/driftskonto bokförs direkt.',
  'trv.noExpenses': 'Inga utlägg registrerade.',
  'trv.toPayroll': 'Till löneutbetalning',
  'trv.mileageAllowance': 'Milersättning',
  'trv.tollsPrivate': 'Vägavgifter (privat)',
  'trv.privateExpenses': 'Privata utlägg',
  'trv.postingSuggestion': 'Förslag till bokföring',
  'trv.owedToEmployee': 'Skuld lön / ersättning anställd',
  'trv.previewComing': 'Förhandsvisning av reseräkning och bilagor kommer här.',
  'trv.privateRefundOf': 'Privat ersättning på',
  'trv.reasonShownToEmployee': 'Motiveringen visas för den anställda i personalportalen.',
  'trv.reason': 'Motivering',
  'trv.whatMustBeFixed': 'Vad måste rättas innan resan eller utlägget kan godkännas?',
  'trv.subShort': 'Reseräkningar, milersättning och utlägg kopplade till anställda. Privata utlägg går till nästa löneutbetalning - företagskort/företagskonto bokförs direkt och hålls utanför lönen.',
  'trv.newTravel': 'Ny resa',
  'trv.getStarted': 'Registrera en resa eller ett utlägg för att komma igång.',
  'trv.submitTravel': 'Skicka in resa',
  'trv.reject': 'Avvisa',
  'trv.accommodation': 'Logi',
  'trv.subsistenceHelp': 'Traktamente (kostersättning) vid övernattning beräknas enligt statens satser och betalas ut skattefritt till den anställda.',
  'trv.noAccommodation': 'Ingen logi registrerad.',
  'trv.subsistenceOvernight': 'Traktamente (övernattning)',
  'trv.optionalNotePh': 'Valfri anteckning, projekt eller referens',
  'trv.editTravel': 'Ändra resa',
  'trv.pickDate': 'Välj datum',
  'trv.route': 'Sträcka',
  'trv.kilometreCount': 'Antal kilometer',
  'trv.sameRouteReturn': 'Använd samma sträcka för returen',
  'trv.pickVehicle': 'Välj fordon',
  'trv.tollsNok': 'Vägavgifter (NOK)',
  'trv.paymentMethod': 'Betalningsmetod',
  'trv.companyCardOperating': 'Företagskort (företagskonto)',
  'trv.vatOnReceipt': 'Moms på kvittot',
  'trv.vatNone': 'Ingen / inget avdrag',
  'trv.enterPassengerName': 'Ange passagerarens namn',
  'trv.enterKilometres': 'Fyll i antal kilometer',
  'trv.kmWithTrailer': 'Kilometer med släp',
  'trv.kmForestRoad': 'Kilometer på skogs- och arbetsväg',
  'trv.newStay': 'Ny vistelse',
  'trv.stayType': 'Typ av vistelse',
  'trv.otherAccommodationCooking': 'Annan logi m. kokmöjlighet',
  'trv.mealsPaidYourself': 'Måltider du betalade själv',
  'trv.pickForWholeStay': 'Välj för hela vistelsen',
  'trv.breakfast': 'Frukost',
  'trv.lunch': 'Lunch',
  'trv.dinner': 'Middag',
  'trv.vehicle': 'Fordon',
  'trv.paymentMethod2': 'Betalningssätt',
  'trv.requiredBeforeRegister': 'Beskrivning, belopp och minst en bilaga krävs innan du kan registrera.',
  'trv.companyCardDirectHelp': 'Företagskort/företagskonto bokförs direkt och hålls utanför löneutbetalningen.',
  'registry.toggle': 'Sök i Brreg',
  'registry.toggleHelp': 'Föreslår företag medan du skriver. Stäng av för privatkunder.',
  'registry.searching': 'Söker i Brreg...',
  'registry.needNineDigits': 'Skriv 9 siffror för att söka org.nr i Brreg.',
  'registry.noHits': 'Inga träffar i Brreg.',
  'registry.failed': 'BRREG-sökningen misslyckades.',
  'sup.invoices': 'Leverantörsfakturor',
  'sup.invoicesHelp': 'Alla fakturor och kreditfakturor från den här leverantören. ”Inte betald” är öppen leverantörsskuld, ”Betald” är reglerad och en kreditfaktura är en återbetalning/korrigering från leverantören.',
  'sup.noInvoicesMatch': 'Inga leverantörsfakturor matchade filtret.',
  'sup.seeVoucher': 'Se verifikation',
  'sup.goTo': 'Gå till',
  'sup.number': 'Leverantörsnr',
  'sup.numberShort': 'Lev.nr',
  'sup.numberPh': 'T.ex. 20001',
  'sup.name': 'Leverantörsnamn',
  'sup.emailPh': 'faktura@leverandor.no',
  'sup.addressPh': 'Gatuadress, postnr och ort',
  'sup.searchPh': 'Sök bland leverantörer ...',
  'sup.searchListPh': 'Sök på leverantör eller belopp',
  'sup.searchHelp': 'Sök efter en leverantör på nummer, namn, organisationsnummer, kontaktuppgifter, totala köp eller utestående belopp.',
  'sup.totalPurchases': 'Totala köp',
  'sup.mergeTitle': 'Slå ihop leverantörer',
  'sup.mergeIntro': 'Har du skapat samma leverantör två gånger?',
  'sup.mergeSwap': 'Byt vilken leverantör som behålls',
  'sup.sameInvoiceNumber': 'Samma fakturanummer är registrerat på båda leverantörerna.',
  'sup.checkDuplicates': 'Kontrollera att köpen inte är dubbletter innan du slår ihop.',
  'sup.exportCsv': 'Leverantörer CSV',
  'sup.exportExcel': 'Leverantörer Excel',
  'sup.ledgerCsv': 'Leverantörsreskontra CSV',
  'sup.ledgerExcel': 'Leverantörsreskontra Excel',
  'sup.whoYouBuyFrom': 'Vilka du köper från',
  'sup.outstandingHelp': 'Hur mycket du är skyldig leverantören just nu — summan av obetalda leverantörsfakturor (leverantörsskuld). Står det 0 har du inga öppna fakturor till den här leverantören.',
  'sup.totalPurchasesHelp': 'Det sammanlagda belopp du har köpt från den här leverantören totalt — både betalda och obetalda fakturor.',
  'sup.balance.youOwe': 'Du är skyldig leverantören {amount}',
  'sup.balance.supplierOwes': 'Leverantören är skyldig dig {amount}',
  'sup.ledger.empty': 'Inga reskontrarader ännu.',
  'sup.status.posted': 'Bokförd',
  'sup.status.partial': 'Delbetald',
  'sup.status.unpaid': 'Inte betald',
  'sup.status.credit': 'Kreditfaktura',
  'sup.status.invoice': 'Faktura',
  'sup.filter.all': 'Alla',
  'sup.sheet.suppliers': 'Leverantörer',
  'sup.sheet.ledger': 'Leverantörsreskontra',
  'sup.export.internalId': 'Internt ID',
  'sup.ledger.type.supplierInvoice': 'Leverantörsfaktura',
  'sup.ledger.type.payment': 'Leverantörsbetalning',
  'sup.ledger.type.importedInvoice': 'Importerad leverantörsfaktura',
  'sup.excelUnavailable': 'Excel-export är inte tillgänglig ännu.',
  'sup.voucherUnderTransactions': 'Verifikationen finns under Transaktioner.',
  'sup.voucherFallbackName': 'Verifikation',
  'sup.voucherViewNotConnected': 'Visning av verifikationer är inte kopplad till backend.',
  'sup.cannotShowVoucher': 'Det gick inte att visa verifikationen.',
  'sup.cannotFetchVoucher': 'Det gick inte att hämta verifikationen från backend.',
  'sup.previewVoucher': 'Förhandsgranska verifikationen',
  'sup.noVoucherUploaded': 'Ingen verifikation uppladdad',
  'sup.nameRequired': 'Leverantörsnamn måste fyllas i.',
  'sup.saveFailed': 'Det gick inte att spara leverantören.',
  'sup.editTitle': 'Uppdatera leverantör',
  'sup.updateAction': 'Uppdatera',
  'sup.saveAction': 'Spara',
  'sup.defaultDueDaysLabel': 'Standard betalningsvillkor (dagar)',
  'sup.defaultCostAccountLabel': 'Standard kostnadskonto',
  'sup.defaultSettlementAccountLabel': 'Standard betalkonto',
  'sup.costAccountPh': 't.ex. 6300',
  'sup.settlementAccountPh': 't.ex. 1920',
  'sup.mergePickerPlaceholder': 'Välj leverantör ...',
  'sup.mergeKeep': 'Behålls',
  'sup.mergeRemove': 'Slås ihop och tas bort',
  'sup.mergeSuccess': 'Leverantörerna har slagits ihop',
  'sup.mergeBackendNotReady': 'Sammanslagning i backend är inte klar.',
  'sup.mergeFailed': 'Det gick inte att slå ihop leverantörerna.',
  'sup.merging': 'Slår ihop...',
  'sup.mergeAction': 'Slå ihop leverantörer',
  'sup.mergeModalIntro': 'Välj dubbletten. Köp och fakturor flyttas till leverantören som behålls, och den andra leverantören tas bort.',
  'sup.mergeFieldLabel': 'Vilken leverantör är samma som {name}?',
  'sup.mergeMoreInvoiceNumbers': '+ {count} fler fakturanummer',
  'sup.noSuppliersToExport': 'Inga leverantörer att exportera',
  'sup.exportListFailed': 'Det gick inte att exportera leverantörslistan.',
  'sup.exportListDone': 'Leverantörslistan har laddats ner',
  'sup.noLedgerRowsToExport': 'Inga reskontrarader att exportera',
  'sup.exportLedgerFailed': 'Det gick inte att exportera leverantörsreskontran.',
  'sup.exportLedgerDone': 'Leverantörsreskontran har laddats ner',
  'sup.updated': 'Leverantören har uppdaterats',
  'sup.saved': 'Leverantören har sparats',
  'sup.archived': 'Leverantören har flyttats till arkivet',
  'sup.archiveFailed': 'Det gick inte att arkivera leverantören.',
  'sup.reopened': 'Leverantören har öppnats igen',
  'sup.reopenFailed': 'Det gick inte att öppna leverantören igen.',
  'sup.titleHelp': 'Leverantörsregistret samlar alla du köper från — namn, org.nr, kontaktuppgifter och kontonummer för utbetalningar. När du registrerar köp och leverantörsfakturor kopplas de till rätt leverantör här.',
  'sup.downloadHelp': 'Ladda ner leverantörslistan eller leverantörsreskontran som CSV eller Excel.',
  'sup.addHelp': 'Skapa en ny leverantör manuellt. Fyll i namn och org.nr så kan du koppla köp och fakturor till den. Nya leverantörer skapas ofta automatiskt när du bokför ett köp.',
  'sup.col.name': 'Leverantör',
  'sup.reopenAction': 'Öppna igen',
  'sup.archiveAction': 'Arkivera',
  'sup.mergeHelp': 'Slå ihop två leverantörer till en. Användbart när samma leverantör är registrerad flera gånger. All historik och alla fakturor flyttas till leverantören du behåller.',
  'sup.enterName': 'Ange leverantörsnamn.',
  'sup.registryNotConnected': 'Leverantörsregistret är inte kopplat till backend.',
  'sup.saveSuccess': 'Leverantören har sparats.',
  'sup.saveSupplierAction': 'Spara leverantör',
  'bg.stepsHelp': 'Stegen leder dig genom en uppgift i taget. En bock betyder att kontrollen är klar; en siffra visar vad som fortfarande behöver uppmärksamhet.',
});
